import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/AddEdit.scss";
import axios from "axios";
import Loading from "../../../Student/Reusablecomponents/Loading";
import TinyMCEDitor from "../../../ReusableComponents/tinymceEditor";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  MainSource,
  SubMainSource,
} from "../../../ReusableComponents/QBDropdowns";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import * as Yup from "yup";
import axiosInstance from "../../../ReusableComponents/Axios";
import QBCList from "../../../ReusableComponents/QBCheckList";
import {
  StageDD, CircularGoalDD, CompetenciesDD,
} from "../../../ReusableComponents/QBAdmin/CommonDropdowns";
import AP from "../Assests/images/AParameters.svg";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
const AddEditScenario = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);
  const updateScenario = useSelector((state) => state.ScenarioDeatils.ScenarioDetails);

  const [Load, SetLoad] = useState(false);
  const [NTDeatils, SetNTDeatils] = useState(updateScenario?.mainSourceLovId);
  const [NTBased, SetNTBased] = useState(updateScenario?.sSourceId);
  const [AQErrors, SetAQErrors] = useState({});
  const [GetEditorValue, SetGetEditorValue] = useState(updateScenario?.scenarioName);
  const [OtherComents, SetOtherComents] = useState(updateScenario?.qsOthersComments);
  const [SStage, SetSStage] = useState(updateScenario?.stage || "");
  const [SCGoal, SetSCGoal] = useState(updateScenario?.curricularGoal || "");
  const [Competencie, SetCompetencie] = useState(updateScenario?.competency || "");
  const [OpenDeatils, SetOpenDeatils] = useState(false);
  const [FSCGoal, SetFSCGoal] = useState();
  const [FCompetencie, SetFCompetencie] = useState();
  const AddScenario = async () => {
    if (GetEditorValue?.length > 0) {
      SetLoad((prev) => !prev);
      const ScenarioDetails = {
        scenario: GetEditorValue.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
        subjectID: items?.subjectId,
        mainSourceLovId: NTDeatils,
        sSourceId: NTBased,
        otherScenarioComments: OtherComents,
        createdBy: items?.userId,
        addScenarioQuestionChecklist: SCValues,
        stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
      };
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + `/Scenario/AddScenario`,
          ScenarioDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data >= 5) {
            notify("Scenario added successfully", "success");
            navigate(-1);
          } else {
            notify("Scenario already exists", "error");
          }
        })
        .catch((err) => {
          notify("Scenario not added. Please try again", "error");
        });
      SetLoad((prev) => !prev);
    } else {
      notify("Scenario field is required", "warning");
    }
  };
  const EditScenario = async () => {
    SetLoad((prev) => !prev);
    const ScenarioDetails = {
      scenarioID: updateScenario?.scenarioID,
      scenario: GetEditorValue,
      subjectID: items?.subjectId,
      mainSourceLovId: NTDeatils,
      sSourceId: NTBased,
      otherScenarioComments: OtherComents,
      modifiedBy: items?.userId,
      AddScenarioQuestionChecklist: SCValues,
      stage: SStage,
      curricularGoal: SCGoal,
      competency: Competencie, 
      language: "",
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/Scenario/UpdateScenario`,
        ScenarioDetails,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Scenario updated successfully", "success");
        navigate(-1, { state: { SList: location.state?.SList || 1 } });
      })
      .catch((err) => {
        notify("Scenario not updated. Please try again", "error");
      });

    SetLoad((prev) => !prev);
  };

  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    NTDeatils: Yup.string().required("Source is required"),
    GetEditorValue: Yup.string().required("Scenario is required"),
    SStage: Yup.string().required("Stage is required"),
    SCGoal: Yup.string().required("Curricular Goal is required"),
    Competencie: Yup.string().required("Competencies is required"),
  });
  const Validation = () => {
    const AllFields = { GetEditorValue, NTBased, NTDeatils, SStage, SCGoal, Competencie, };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        SetAQErrors({});
        if (CValidation) {
          if (updateScenario) {
            EditScenario();
          } else {
            AddScenario();
          }
        }
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };

  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [SCValues, SetSCValues] = useState();
  useEffect(() => {
    if (CValidation) {
      Validation();
    }
  }, [CValidation]);

  const Columns = [
    { name: "Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "lovDescription", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.lovDescription} </div>),
    },
  ];
  return (
    <>
      <div className="MainHeading">
        {updateScenario ? "Update" : "Add"} Scenario
      </div>
      <div className="Card mt-2">
        <div className="container-fluid">
          <div className="m-2">
            Scenario Source <span className="text-danger">*</span>
          </div>

          <Row>
            <Col>
              <MainSource className="NCLDropdown w-100"
                StoreMSource={SetNTDeatils} SOption={NTDeatils}
                LID={SelectLanguage} onChange={(e) => SetNTDeatils(e)} />
              {AQErrors?.NTDeatils && (<span className="error-message">{AQErrors?.NTBased}</span>)}
            </Col>
            <Col>
              <SubMainSource className="NCLDropdown w-100" StoreSMSource={SetNTBased} SOption={NTBased}
                PId={NTDeatils} LID={SelectLanguage} onChange={(e) => SetNTBased(e)} />
              {AQErrors?.NTBased && (<span className="error-message">{AQErrors?.NTBased}</span>)}
              {(NTBased === "3574" || NTBased === "3578") && (
                <input type="text" className=" Search mt-2 p-1 w-100"
                  onChange={(e) => SetOtherComents(e.target.value)} placeholder="Enter Comments" />)}
            </Col>
          </Row>

          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div> Competencies<span className="text-danger">*</span></div>
              </div>{" "}
            </div>
            <div className="container-fluid">
              <Row>
                <Col>
                  <StageDD className="NCLDropdown w-100" StoreMSource={SetSStage} SOption={SStage}
                    onChange={(e) => {SetSStage(e);SetSCGoal("");SetCompetencie("");SetFCompetencie("");}}
                     Displayname="Select Stage" LID={items?.subjectId == 1 ? 99 : 102} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Stage<span>*</span> </div>} />
                  {AQErrors?.SStage && (<span className="error-message"> {AQErrors?.SStage} </span>)}
                </Col>
                <Col>
                  <CircularGoalDD className="NCLDropdown w-100" StoreMSource={SetSCGoal} SOption={SCGoal}
                    onChange={(e) => {SetSCGoal(e);SetCompetencie("");}} Displayname="Select Curricular Goal" LID={items?.subjectId == 1 ? 100 : 103} PId={SStage} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Curricular Goal<span>*</span> </div>} GetDetails={SetFSCGoal} />
                  {AQErrors?.SCGoal && (<span className="error-message"> {AQErrors?.SCGoal} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FSCGoal)}
                  > <IoInformationCircleOutline /> Click to view Curricular Goal description </div>
                </Col>
                <Col>
                  <CompetenciesDD className="NCLDropdown w-100" StoreMSource={SetCompetencie} SOption={Competencie}
                    onChange={(e) => SetCompetencie(e)} Displayname="Select Competencies" LID={items?.subjectId == 1 ? 101 : 104} PId={SCGoal} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Competencies<span>*</span> </div>} GetDetails={SetFCompetencie} />
                  {AQErrors?.Competencie && (<span className="error-message"> {AQErrors?.Competencie} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FCompetencie)}
                  > <IoInformationCircleOutline /> Click to view Competencies description </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="m-2"> Scenario <span className="text-danger">*</span> </div>
          <TinyMCEDitor onChange={(e) => SetGetEditorValue(e)} PostValue={GetEditorValue} />
          {AQErrors?.GetEditorValue && (<span className="error-message">{AQErrors?.GetEditorValue}</span>)}
          <QBCList Heading="Scenario" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
            GetValues={SetSCValues} Existinvalues={updateScenario?.status} ExistingId={updateScenario?.checklistQuestionId} LanguageId={SelectLanguage} />
          <div className="ScenarioAU dflex alignitems">
            <button className="Buttons bg-danger" onClick={() => navigate(-1)}> Cancel </button>
            <button className="Buttons bg-success" onClick={() => { Validation(); SetHitCLV(true); }}>
              {updateScenario ? (
                <> Update <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The Scenario) </span> </>
              ) : ("Save")} </button>
          </div>
        </div>
      </div>


      {OpenDeatils && (
        <div className="Model-Open">
          <div className="Card w-100 Model-Content">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => SetOpenDeatils()}
            />
            <DataTable data={OpenDeatils} columns={Columns} className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default AddEditScenario;